import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

// Key for localStorage
const LANGUAGE_KEY = 'cocon_language';

export const LanguageProvider = ({ children }) => {
  // Initialize from localStorage or default to 'fr'
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(LANGUAGE_KEY) || 'fr';
    }
    return 'fr';
  });

  // Persist language choice to localStorage
  useEffect(() => {
    localStorage.setItem(LANGUAGE_KEY, language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  const t = (translations) => {
    return translations[language] || translations['fr'];
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
